/* eslint-disable @typescript-eslint/no-explicit-any */
import moment from "moment";
import { postData } from "./postData";
import { updateData } from "./updateData";
import { urlEnum } from "../Utils/urlEnum";
import { disableTostifyConfig } from "../Utils/utils";

// MySQL's zero-date sentinel for an empty/invalid DATE column; treat it the
// same as a missing acquisition date rather than forwarding it as-is.
const ZERO_DATE = "0000-00-00";

export function buildSaveVehicleUrl(vehicleId: any, disableTostify?: boolean): string {
  if (!vehicleId) {
    return urlEnum.vehicles;
  }
  return `${urlEnum.vehicles}/${vehicleId}${
    disableTostify ? disableTostifyConfig : ""
  }`;
}

export function saveVehicleRequest(vehicle: any, disableTostify?: boolean) {
  const url = buildSaveVehicleUrl(vehicle.id, disableTostify);
  const sendRequest = vehicle.id ? updateData : postData;
  return sendRequest(url, vehicle);
}

export function buildVehicleFileFormData(
  vehicle: any,
  parentDocArray: any[],
  fileType: string,
  documentType: string,
  statusFinanciar: string
): FormData {
  const formData = new FormData();
  formData.append("vehicul_id", vehicle?.id);
  formData.append("vin", vehicle?.vin);
  const acquisitionDate =
    vehicle?.data_achizitie && vehicle.data_achizitie !== ZERO_DATE
      ? vehicle.data_achizitie
      : moment().format("YYYY-MM-DD");
  formData.append("date", acquisitionDate);
  formData.append(
    "descriere_financiar",
    ` ${parentDocArray[0] && parentDocArray[0]?.name}`
  );
  formData.append("suma_financiar", vehicle?.pret_achizitie_euro);
  formData.append("fileType", fileType);
  formData.append("type", documentType);
  formData.append("status_financiar", statusFinanciar);
  formData.append("file_id", parentDocArray && parentDocArray[0]);
  return formData;
}

export function buildSaveVehicleFileUrl(
  existingFileId: any,
  vehicleId: any,
  fileType: string
): string {
  if (!existingFileId) {
    return urlEnum.files;
  }
  return `${urlEnum.files}/${existingFileId}/${vehicleId}/${fileType}`;
}

export function saveVehicleFileRequest(
  formData: FormData,
  existingFileId: any,
  vehicleId: any,
  fileType: string
) {
  const url = buildSaveVehicleFileUrl(existingFileId, vehicleId, fileType);
  return postData(url, formData);
}

export function updateVehicleAfterFileSave(vehicleId: any, vehicleData: any) {
  return updateData(`${urlEnum.vehicles}/${vehicleId}`, vehicleData);
}

export function saveMainImageRequest(file: File, vehicleId: number | string) {
  const url = `${urlEnum.vehicles}/update/main/image/${vehicleId}`;
  const formData = new FormData();
  formData.append("vehicul_id", String(vehicleId));
  formData.append("fileType", "Poze");
  formData.append(file.name, file);
  return postData(url, formData);
}
